import { Injectable } from '@angular/core';
import 'hammerjs';
@Injectable()
export class ThemeConfig {

	public constructor() {}

}



// WEBPACK FOOTER //
// ./src/app/theme/theme.config.ts